<div class="flex items-center gap-2">
	<span class="font-medium">Helpful review?</span>
	<!-- thumbs up-->
	<!-- if user has not liked the review -->
	@if (reaction() !== 'LIKE') {
		<button
			(click)="onReviewReaction(react.LIKE, reviewId())"
			class="text-black transition-all only-tab-focus hover:text-uc-green-900"
		>
			<uc-thumbs-up-outline-svg />
		</button>
	} @else {
		<!-- if user has liked the review -->
		@if (reaction() === 'LIKE') {
			<button
				(click)="onReviewReaction(react.LIKE, reviewId())"
				class="transition-all text-uc-green-900 only-tab-focus"
			>
				<uc-thumbs-up-solid-svg />
			</button>
		}
	}
	@if (likes()) {
		<span>{{ likes() }}</span>
	}

	<!-- thumbs down-->
	<!-- if not disliked -->
	@if (reaction() !== 'DISLIKE') {
		<button
			(click)="onReviewReaction(react.DISLIKE, reviewId())"
			class="text-gray-900 transition-all hover:text-uc-red-900 only-tab-focus"
		>
			<uc-thumbs-down-outline-svg />
		</button>
	} @else {
		<!-- if disliked -->
		@if (reaction() === 'DISLIKE') {
			<button
				(click)="onReviewReaction(react.DISLIKE, reviewId())"
				class="transition-all text-uc-red-900 only-tab-focus"
			>
				<uc-thumbs-down-solid-svg />
			</button>
		}
	}
	@if (dislikes()) {
		<span>{{ dislikes() }}</span>
	}
</div>
